import moment from "moment";
import { FilaProcedimentoEnum } from "../helpers/enums.js";
import {
    firebaseFire as Libfirebase,
} from "../helpers/firebase-config.js";
import axios from "axios";
import { apiEndpoint, getApiToken, getStorageToken } from "../helpers/utils.js";

export async function getFilasOpened(secretariaId) {
    const filas = await Libfirebase.collection("fila_procedimento")
        .where('secretaria_id', '==', secretariaId)
        .where('status', '==', FilaProcedimentoEnum.Aguardando)
        .get()
    return filas.docs.map((doc) => {
        return {
            id: doc.id,
            ref: doc.ref,
            ...doc.data(),
        }
    })
}

export async function getFilasStatus(status, secretariaId, dataIni, dataFim) {
    const filas = await Libfirebase.collection("fila_procedimento")
        .where('secretaria_id', '==', secretariaId)
        .where('status', '==', status)
        .where("data_fila", ">=", dataIni)
        .where("data_fila", "<=", dataFim)
        .get()
    return filas.docs.map((doc) => {
        return {
            id: doc.id,
            ref: doc.ref,
            ...doc.data(),
        }
    })
}

export async function getFilaById(id) {
    const docId = typeof id === 'string' ? id : (id && id.id) || id;
    if (!docId) return null;
    const doc = await Libfirebase.collection("fila_procedimento").doc(docId).get()
    if (!doc.exists) return null
    return {
        id: doc.id,
        ref: doc.ref,
        ...doc.data(),
    }
}

export async function getPacienteFila(pacienteId) {
    const token = await getStorageToken()
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        },
    };
    const resp = await axios.get(`${apiEndpoint()}/fila-procedimento/paciente/${pacienteId}`, config)
    return resp.data


    // let filas = await Libfirebase.collection("fila_procedimento")
    //     .where('paciente_id', '==', pacienteId)
    //     .where('viagemId', '==', null)
    //     .get()

    // return filas.docs.map(doc => {
    //     return {
    //         id: doc.id,
    //         ref: doc.ref,
    //         ...doc.data(),
    //     }
    // })
}

export async function getPacienteFila2(pacienteId) {
    let filas = await Libfirebase.collection("fila_procedimento")
        .where('paciente_id', '==', pacienteId)
        .get()

    return filas.docs.map(doc => {
        return {
            id: doc.id,
            ref: doc.ref,
            ...doc.data(),
        }
    })
}

export async function saveFila(data) {
    return await Libfirebase.collection("fila_procedimento").add(data)
}

export async function updateFila(id, data) {
    return await Libfirebase.collection("fila_procedimento").doc(id).update(data)
}

export async function saveLogFila(id, data) {
    return await Libfirebase
        .collection("fila_procedimento")
        .doc(id)
        .collection("log_fila")
        .add(data)
}

export async function getGruposProc() {
    const token = await getStorageToken()
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        },
    };
    const resp = await axios.get(`${apiEndpoint()}/sigtap/grupo`, config)
    return resp.data

    // const grupos = await Libfirebase.collection("procedimentos_grupo").get()
    // return grupos.docs.map((doc) => {
    //     return {
    //         id: doc.id,
    //         ref: doc.ref,
    //         ...doc.data(),
    //     }
    // })
}

export async function getSubGruposProc(grupoId) {
    const token = await getStorageToken()
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        },
    };
    const resp = await axios.get(`${apiEndpoint()}/sigtap/sub-grupo/${grupoId}`, config)
    return resp.data

    // const grupos = await Libfirebase.collection("procedimentos_sub_grupo")
    //     .where('grupo', '==', grupoId)
    //     .get()
    // return grupos.docs.map((doc) => {
    //     return {
    //         id: doc.id,
    //         ref: doc.ref,
    //         ...doc.data(),
    //     }
    // })
}

export async function getFormaOrganizacaoProc(grupoId, subGrupoId) {
    const token = await getStorageToken()
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        },
    };
    const resp = await axios.get(`${apiEndpoint()}/sigtap/forma-organizacao/${grupoId}/${subGrupoId}`, config)
    return resp.data
    // const grupos = await Libfirebase.collection("procedimentos_forma_organizacao")
    //     .where('grupo', '==', grupoId)
    //     .where('sub_grupo', '==', subGrupoId)
    //     .get()

    // return grupos.docs.map((doc) => {
    //     return {
    //         id: doc.id,
    //         ref: doc.ref,
    //         ...doc.data(),
    //     }
    // })
}

export async function getProcedimentos(grupoId, subGrupoId, formaOrganizacaoId = null) {
    const token = await getStorageToken()
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        },
    };
    const resp = await axios.get(`${apiEndpoint()}/sigtap/procedimentos/${grupoId}/${subGrupoId}/${formaOrganizacaoId}`, config)
    return resp.data

    // let query = Libfirebase.collection("procedimentos_sus")
    //     .where('grupo', '==', grupoId)
    //     .where('sub_grupo', '==', subGrupoId)

    // if (formaOrganizacaoId) {
    //     query.where('forma_organizacao', '==', formaOrganizacaoId)
    // }
    // const procedimentos = await query.get()

    // return procedimentos.docs.map((doc) => {
    //     return {
    //         id: doc.id,
    //         ref: doc.ref,
    //         ...doc.data(),
    //     }
    // })
}

export async function getProcedimentosDropdown(words) {
    const token = await getStorageToken()
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        },
        params: { words }
    };
    const resp = await axios.get(`${apiEndpoint()}/sigtap/procedimentos-query`, config)
    return resp.data
}

export async function setFilaViagemId(id, viagemId, userId, dataViagem) {
    const docId = typeof id === 'string' ? id : (id && id.id) || id;
    if (!docId || typeof docId !== 'string') {
        throw new Error('setFilaViagemId: id deve ser uma string ou referência com .id');
    }
    const dataViagemVal = dataViagem != null
        ? (typeof dataViagem === 'string' ? dataViagem : (dataViagem && dataViagem.toDate ? moment(dataViagem.toDate()).format('YYYY-MM-DD') : (dataViagem && dataViagem.seconds ? moment.unix(dataViagem.seconds).format('YYYY-MM-DD') : String(dataViagem))))
        : null;
    return await Libfirebase
        .collection("fila_procedimento")
        .doc(docId)
        .update({
            viagemId: viagemId,
            user_set_viagem: userId,
            data_viagem: dataViagemVal,
            updated_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        })
}

export async function getFilasByViagemId(viagemId) {
    const filas = await Libfirebase.collection("fila_procedimento")
        .where('viagemId', '==', viagemId)
        .get()

    return filas.docs.map(doc => {
        return {
            id: doc.id,
            ref: doc.ref,
            ...doc.data(),
        }
    })
}

export async function getFilasByDateAndSecretaria(date, secretariaId) {
    console.log(date)
    console.log(secretariaId)
    const filas = await Libfirebase.collection("fila_procedimento")
        .where('secretaria_id', '==', secretariaId)
        .where('status', '==', FilaProcedimentoEnum.ProcedimentoAgendado)
        .where("data_agendamento", "==", date)
        .get()

    return filas.docs.map(doc => {
        return {
            id: doc.id,
            ref: doc.ref,
            ...doc.data(),
        }
    })
}

export async function getFilasRelatorioAguardando(
    secretariaId,
    dataInicial,
    dataFinal,
    procedimento,
    status
) {
    const token = await getStorageToken()
    // console.log(procedimento?.value?.id)
    const proc = procedimento ? procedimento.value.id : procedimento

    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        },
        params: {
            secretariaId,
            dataInicial,
            dataFinal,
            procedimento: proc,
            status
        }
    };

    return axios.get(`${apiEndpoint()}/fila-procedimento`, config)

    // let query = Libfirebase.collection("fila_procedimento")
    //     .where('secretaria_id', '==', secretariaId)
    //     .where("data_fila", ">=", dataIni)
    //     .where("data_fila", "<=", dataFin)
    //     .where("status", "==", FilaProcedimentoEnum.Aguardando)

    // if (procedimento) {
    //     query += query.where("procedimento_id ", "==", procedimento)
    // }

    // const filaDB = await query.get()
    // return filaDB.docs.map(doc => {
    //     return {
    //         id: doc.id,
    //         ref: doc.ref,
    //         ...doc.data(),
    //     }
    // })
}


export async function getFilasExcel(
    secretariaId,
    dataInicial,
    dataFinal,
    procedimento,
    status
) {
    try {
        const token = await getStorageToken()
        const proc = procedimento ? procedimento.value.id : procedimento

        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
            params: {
                secretariaId,
                dataInicial,
                dataFinal,
                procedimento: proc,
                status
            },
            responseType: 'blob',
        };

        const response = await axios.get(`${apiEndpoint()}/fila-procedimento/excel`, config)

        // Cria um URL para o blob que representa o arquivo
        const url = window.URL.createObjectURL(new Blob([response.data]));

        // Cria um link temporário
        const link = document.createElement('a');
        link.href = url;

        // Define o nome do arquivo para download
        link.setAttribute('download', 'fila_procedimento.xlsx');

        // Simula um clique no link para iniciar o download
        document.body.appendChild(link);
        link.click();

        // Remove o link temporário
        document.body.removeChild(link);
    } catch (error) {
        console.error('Erro ao fazer o download do arquivo:', error);
        throw error
    }
}

/* tabelas sigtap */
export async function getUltimaImportacao() {
    const token = await getStorageToken()
    return await axios.get(`${apiEndpoint()}/sigtap/dates`, { headers: { 'Authorization': `Bearer ${token}` } })
}

export async function postGrupo(file) {
    const token = await getStorageToken()

    const formData = new FormData();
    formData.append('file', file);
    // formData.append('fileName', file.name);
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        },
    };

    return axios.post(`${apiEndpoint()}/sigtap/grupo`, formData, config)
}

export async function postSubGrupo(file) {
    const token = await getStorageToken()

    const formData = new FormData();
    formData.append('file', file);
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        },
    };

    return axios.post(`${apiEndpoint()}/sigtap/sub-grupo`, formData, config)
}

export async function postFormaOrg(file) {
    const token = await getStorageToken()

    const formData = new FormData();
    formData.append('file', file);
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        },
    };

    return axios.post(`${apiEndpoint()}/sigtap/forma-organizacao`, formData, config)
}

export async function postProcedimento(file) {
    const token = await getStorageToken()

    const formData = new FormData();
    formData.append('file', file);
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        },
    };

    return axios.post(`${apiEndpoint()}/sigtap/procedimento`, formData, config)
}
